import React, { useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Common, SettingsIcons } from "../../../assets/images";
import { EmpDetail } from "../../../interfaces/employee";
// Redux Imports
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setDetailPageBasicInfo,
  setDetailPageAttendanceLog,
  setDetailActiveTab,
  setDetailPageAttachments,
} from "../../../store/slices/employeeSlice";
import { useNavigate } from "react-router-dom";

interface Props {
  empDetail: EmpDetail;
}

const BasicInfo = ({ empDetail }: Props) => {
  // Redux
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const fileExtension = (path: string) => {
    // Using the URL API to extract the pathname
    const pathname = path ? new URL(path).pathname : "";

    // Extracting the file name with extension from the pathname
    const fileNameWithExtension = pathname.split("/").pop();

    return fileNameWithExtension;
  };

  // Using the URL API to extract the pathname
  const pathname = empDetail.agreement.attachment
    ? new URL(empDetail.agreement.attachment).pathname
    : "";

  // Extracting the file name with extension from the pathname
  const fileNameWithExtension = pathname.split("/").pop();

  return (
    <>
      <div
        className="section p-4 emp-detail-block"
        style={{
          border: 0,
          boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
        }}
      >
        <Row>
          <Col sm="12">
            <div className="mb-0 d-flex justify-content-between ">
              <div>
                {empDetail.empImage ? (
                  empDetail.empImage.includes("https") ? (
                    <img
                      src={empDetail.empImage}
                      className=" mb-3"
                      style={{
                        width: "100%",
                        objectFit: "contain",
                      }}
                      alt="setting-icon"
                    />
                  ) : (
                    <img
                      src={Common.UserImgPlaceholder}
                      className=" mb-3"
                      style={{ width: "200px" }}
                      alt="setting-icon"
                    />
                  )
                ) : (
                  <img
                    src={Common.UserImgPlaceholder}
                    className=" mb-3"
                    style={{ width: "200px" }}
                    alt="setting-icon"
                  />
                )}
                <h4
                  className="sub-heading normal-font-weight textBlack mb-0"
                  style={{ fontSize: "28px" }}
                >
                  {empDetail.empName}
                </h4>
                <h5
                  className="sub-heading normal-font-weight"
                  style={{ fontSize: "20px" }}
                >
                  {empDetail.empCategory}
                </h5>
              </div>
              <div>
                <button
                  className="btn primary-button px-5"
                  onClick={() =>
                    navigate(`/employees/edit-employee/${empDetail.empId}`, {
                      state: { empId: empDetail.empId },
                    })
                  }
                >
                  Edit
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Row>
        {/*******************
         ******************
         * Basic Information
         * ******************
         * ******************/}
        <Col sm="6">
          <Row>
            <Col sm="12">
              <div
                className="section emp-detail-block p-4 mt-4"
                style={{
                  border: 0,
                  boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
                  height: "404px",
                  overflow: "auto",
                }}
              >
                <Row>
                  <Col sm="12">
                    <h4
                      className="sub-heading normal-font-weight textBlack mb-4"
                      style={{ fontSize: "24px" }}
                    >
                      Basic Information
                    </h4>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Emp Id
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empId}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Place
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empPlace}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Category
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empCategory}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Nationality
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empNationality}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Religion
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empReligion}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Company Name
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empCompanyName}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Mobile No.
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empPhone}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Employee Status
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empStatus}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0 d-flex justify-content-between">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Date of Birth
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {new Date(empDetail.empDob).toLocaleDateString()}
                      </h5>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>
            {/*
            **********************
            **********************
            Other Details
            **********************
            **********************
            */}
            <Col sm="12">
              <div
                className="section emp-detail-block p-4 mt-4"
                style={{
                  border: 0,
                  boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
                  height: "404px",
                  overflow: "auto",
                }}
              >
                <Row>
                  <Col sm="12">
                    <h4
                      className="sub-heading normal-font-weight textBlack mb-4"
                      style={{ fontSize: "24px" }}
                    >
                      Other Details
                    </h4>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Duty Hours
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.dutyHours}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Salary Period
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.salaryPeriod}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Basic Salary
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        SAR {empDetail.basicSalary}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Total Salary
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        SAR {empDetail.empTotalSalary}
                      </h5>
                    </Form.Group>
                  </Col>
                  {empDetail.campDetails ? (
                    <Col sm="12">
                      <Row>
                        {empDetail.empNationality !== "Saudi Arabia" && (
                          <>
                            <Col sm="12">
                              <Form.Group className="mb-0 d-flex justify-content-between">
                                <h4
                                  className="sub-heading normal-font-weight textBlack"
                                  style={{ fontSize: "16px" }}
                                >
                                  Camp Id
                                </h4>
                                <h5
                                  className="sub-heading normal-font-weight"
                                  style={{ fontSize: "14px" }}
                                >
                                  {empDetail.campDetails.campId}
                                </h5>
                              </Form.Group>
                            </Col>
                            <Col sm="12">
                              <Form.Group className="mb-0 d-flex justify-content-between">
                                <h4
                                  className="sub-heading normal-font-weight textBlack"
                                  style={{ fontSize: "16px" }}
                                >
                                  Camp Name
                                </h4>
                                <h5
                                  className="sub-heading normal-font-weight"
                                  style={{ fontSize: "14px" }}
                                >
                                  {empDetail.campDetails.campName}
                                </h5>
                              </Form.Group>
                            </Col>
                            <Col sm="12">
                              <Form.Group className="mb-0 d-flex justify-content-between">
                                <h4
                                  className="sub-heading normal-font-weight textBlack"
                                  style={{ fontSize: "16px" }}
                                >
                                  Camp City
                                </h4>
                                <h5
                                  className="sub-heading normal-font-weight"
                                  style={{ fontSize: "14px" }}
                                >
                                  {empDetail.campDetails.campCity}
                                </h5>
                              </Form.Group>
                            </Col>
                          </>
                        )}
                        <Col sm="12">
                          <Form.Group className="mb-0 d-flex justify-content-between">
                            <h4
                              className="sub-heading normal-font-weight textBlack"
                              style={{ fontSize: "16px" }}
                            >
                              Department
                            </h4>
                            <h5
                              className="sub-heading normal-font-weight"
                              style={{ fontSize: "14px" }}
                            >
                              {empDetail.empDepartment}
                            </h5>
                          </Form.Group>
                        </Col>
                        {empDetail.empNationality !== "Saudi Arabia" && (
                          <Col sm="12">
                            <Form.Group className="mb-0 d-flex justify-content-between">
                              <h4
                                className="sub-heading normal-font-weight textBlack"
                                style={{ fontSize: "16px" }}
                              >
                                Home Country Contact
                              </h4>
                              <h5
                                className="sub-heading normal-font-weight"
                                style={{ fontSize: "14px" }}
                              >
                                {empDetail.empHomeCountryNumber}
                              </h5>
                            </Form.Group>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  ) : (
                    <>
                      {empDetail.empNationality !== "Saudi Arabia" && (
                        <Col sm="4">
                          <Form.Group className="mb-3">
                            <h4
                              className="sub-heading normal-font-weight textBlack"
                              style={{ fontSize: "16px" }}
                            >
                              No Camp Information
                            </h4>
                          </Form.Group>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
        {/*
        ******************
        ******************
        Legal Details
        ******************
        ******************
        */}
        <Col sm="6">
          <div
            className="section emp-detail-block p-4 mt-4"
            style={{
              border: 0,
              boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
            }}
          >
            <Row>
              <Col sm="12">
                <h4
                  className="sub-heading normal-font-weight textBlack mb-4"
                  style={{ fontSize: "24px" }}
                >
                  Legal Details
                </h4>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Iqama No.
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empIqamaNo}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Iqama Expiry Date
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {new Date(empDetail.empIqamaExpiry).toLocaleDateString()}
                  </h5>
                </Form.Group>
              </Col>
              {empDetail.empNationality !== "Saudi Arabia" && (
                <Col sm="12">
                  <Form.Group
                    className="mb-0 d-flex justify-content-between"
                    controlId="formBasicEmail"
                  >
                    <h4
                      className="sub-heading normal-font-weight textBlack"
                      style={{ fontSize: "16px" }}
                    >
                      Profession on Iqama
                    </h4>
                    <h5
                      className="sub-heading normal-font-weight"
                      style={{ fontSize: "14px" }}
                    >
                      {empDetail.empProfessionOnIqama}
                    </h5>
                  </Form.Group>
                </Col>
              )}
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Sponsor Name
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empSponsorName}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Sponsor Id No.
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empIdNo}
                  </h5>
                </Form.Group>
              </Col>
              {empDetail.empNationality !== "Saudi Arabia" && (
                <>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Border No.
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empBorderNo}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Iqama Printed
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empIqamaPrinted}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Handover to Employee
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.iqamaHandOverToEmployee}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Passport with Company
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empPassportWithCompany}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Passport No.
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empPassportNo}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Passport Expiry Date
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {new Date(
                          empDetail.empPassportExpiry,
                        ).toLocaleDateString()}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Visa No.
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.empVisaNo}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Entry Date Of Emp In Saudia Arabia
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {new Date(empDetail.dateOfEmpInSA).toLocaleDateString()}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Visa Expiry Date
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {new Date(empDetail.empVisaExpiry).toLocaleDateString()}
                      </h5>
                    </Form.Group>
                  </Col>
                </>
              )}

              {empDetail.recruiterDetails ? (
                <>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Recruiter Id.
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.recruiterDetails.recruiterId}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Recruiter Name
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.recruiterDetails.recruiterName}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Recruiter Company Name
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.recruiterDetails.companyName}
                      </h5>
                    </Form.Group>
                  </Col>
                </>
              ) : (
                <Col sm="12">
                  <Form.Group
                    className="mb-0 d-flex justify-content-between"
                    controlId="formBasicEmail"
                  >
                    <h4
                      className="sub-heading normal-font-weight textBlack"
                      style={{ fontSize: "16px" }}
                    >
                      No Recruiter Details Found
                    </h4>
                  </Form.Group>
                </Col>
              )}
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Work Permit Expiry
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.workPermitExpiry}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Insurance Company
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empInsuranceCompany}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Insurance Expiry
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {new Date(
                      empDetail.empInsuranceExpiry,
                    ).toLocaleDateString()}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Insurance Cost
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empInsuranceCost}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Insurance Status
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.empInsuranceStatus}
                  </h5>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Col>
        {/*
        ******************
        ******************
        Bank Info & Legal Details
        ******************
        ******************
        */}
        <Col sm="6">
          <div
            className="section emp-detail-block p-4 mt-4"
            style={{
              border: 0,
              boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
              height: "100%",
            }}
          >
            <Row>
              <Col sm="12">
                <h4
                  className="sub-heading normal-font-weight textBlack mb-4"
                  style={{ fontSize: "24px" }}
                >
                  Bank Information & Allowances
                </h4>
              </Col>
              {empDetail.allowances.length > 0 && (
                <>
                  <Col sm="12">
                    <h3
                      className="sub-heading mb-4"
                      style={{ fontWeight: "400" }}
                    >
                      Allowances
                    </h3>
                  </Col>
                  <Col sm="12">
                    {empDetail.allowances.map((item, index) => (
                      <div key={index}>
                        <Row>
                          <Col sm="4">
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicEmail"
                            >
                              <h4
                                className="sub-heading normal-font-weight textBlack"
                                style={{ fontSize: "16px" }}
                              >
                                Title
                              </h4>
                              <h5
                                className="sub-heading normal-font-weight"
                                style={{ fontSize: "14px" }}
                              >
                                {item.title}
                              </h5>
                            </Form.Group>
                          </Col>
                          <Col sm="4">
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicEmail"
                            >
                              <h4
                                className="sub-heading normal-font-weight textBlack"
                                style={{ fontSize: "16px" }}
                              >
                                Category
                              </h4>
                              <h5
                                className="sub-heading normal-font-weight"
                                style={{ fontSize: "14px" }}
                              >
                                {item.category}
                              </h5>
                            </Form.Group>
                          </Col>
                          <Col sm="4">
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicEmail"
                            >
                              <h4
                                className="sub-heading normal-font-weight textBlack"
                                style={{ fontSize: "16px" }}
                              >
                                Amount
                              </h4>
                              <h5
                                className="sub-heading normal-font-weight"
                                style={{ fontSize: "14px" }}
                              >
                                {item.amount}
                              </h5>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </Col>
                </>
              )}
              <Col sm="12">
                <div className="section-heading mb-4">
                  <h1
                    className="sub-heading mb-0"
                    style={{ fontWeight: "400" }}
                  >
                    Insurance Update On
                  </h1>
                </div>
              </Col>
              <Col sm="12">
                {empDetail.insuranceHistory.length > 0 ? (
                  <div className="table-responsive mb-3">
                    <table className="table text-center table-bordered">
                      <thead>
                        <tr>
                          <th style={{ fontSize: "16px" }}>Sr.</th>
                          <th style={{ fontSize: "16px" }}>Updation Date</th>
                          <th style={{ fontSize: "16px" }}>Updater Id.</th>
                          <th style={{ fontSize: "16px" }}>Updater Name</th>
                          <th style={{ fontSize: "16px" }}>Cost</th>
                          <th style={{ fontSize: "16px" }}>Attachment</th>
                          <th style={{ fontSize: "16px" }}>Remarks</th>
                          <th style={{ fontSize: "16px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empDetail.insuranceHistory.map((item, index) => (
                          <tr key={index}>
                            <td style={{ fontSize: "14px" }}>{index + 1}</td>
                            <td style={{ fontSize: "14px" }}>
                              {item.updatedOn
                                ? new Date(item.updatedOn).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td style={{ fontSize: "14px" }}>
                              {item.updatedBy}
                            </td>
                            <td style={{ fontSize: "14px" }}>
                              {item.updaterName}
                            </td>
                            <td style={{ fontSize: "14px" }}>{item.cost}</td>
                            <td style={{ fontSize: "14px" }}>
                              {item.attachemnt
                                ? fileExtension(item.attachemnt)
                                : "N/A"}
                            </td>
                            <td>{item.remarks}</td>
                            <td>
                              {item.attachemnt ? (
                                <a href={item.attachemnt} download>
                                  <img
                                    src={Common.Download}
                                    className="me-2"
                                    width="24px"
                                    height="24px"
                                    alt="share"
                                  />
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Col sm="4">
                    <Form.Group className="mb-4" controlId="formBasicEmail">
                      <h4
                        className="sub-heading textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        No updations yet...
                      </h4>
                    </Form.Group>
                  </Col>
                )}
              </Col>
              <Col sm="12">
                <h3 className="sub-heading mt-4" style={{ fontWeight: "400" }}>
                  Bank Information
                </h3>
              </Col>
              <Col sm="12">
                <Row>
                  {empDetail.empBankDetails.length === 0 && (
                    <div className="text-center mt-5">
                      <h1 className="heading">No Bank Info Added</h1>
                    </div>
                  )}
                  {empDetail.empBankDetails.length > 0 && (
                    <div className="table-responsive mb-3">
                      <table className="table text-center table-bordered">
                        <thead>
                          <tr>
                            <th
                              className="bg-transparent"
                              style={{ fontSize: "16px" }}
                            >
                              Sr.
                            </th>
                            <th
                              className="bg-transparent"
                              style={{ fontSize: "16px" }}
                            >
                              Bank Name
                            </th>
                            <th
                              className="bg-transparent"
                              style={{ fontSize: "16px" }}
                            >
                              Bank A/C No. OR IBAN
                            </th>
                            <th
                              className="bg-transparent"
                              style={{ fontSize: "16px" }}
                            >
                              Bank Account Title
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {empDetail.empBankDetails.map((item, index) => (
                            <tr key={index}>
                              <td
                                className="bg-transparent"
                                style={{ fontSize: "14px" }}
                              >
                                {index + 1}
                              </td>
                              <td
                                className="bg-transparent"
                                style={{ fontSize: "14px" }}
                              >
                                {item.empBankName}
                              </td>
                              <td
                                className="bg-transparent"
                                style={{ fontSize: "14px" }}
                              >
                                {item.empBankAccountNo}
                              </td>
                              <td
                                className="bg-transparent"
                                style={{ fontSize: "14px" }}
                              >
                                {item.empBankAccountTitle}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
        {/*
            **********************
            **********************
            Evaluation Details & Agreement
            **********************
            **********************
            */}
        <Col sm="6">
          <div
            className="section emp-detail-block p-4 mt-4"
            style={{
              border: 0,
              boxShadow: "rgba(0.1, 0.1, 0.1, 0.1) 0px 0px 0px 2px",
              height: "100%",
            }}
          >
            <Row>
              <Col sm="12">
                <h4
                  className="sub-heading normal-font-weight textBlack mb-4"
                  style={{ fontSize: "24px" }}
                >
                  Agreement
                </h4>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Agreement Issued Date
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.agreement.issueDate
                      ? new Date(
                          empDetail.agreement.issueDate,
                        ).toLocaleDateString()
                      : "N/A"}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <Form.Group
                  className="mb-0 d-flex justify-content-between"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "16px" }}
                  >
                    Agreement Expiry Date
                  </h4>
                  <h5
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    {empDetail.agreement.expiryDate
                      ? new Date(
                          empDetail.agreement.expiryDate,
                        ).toLocaleDateString()
                      : "N/A"}
                  </h5>
                </Form.Group>
              </Col>
              <Col sm="12">
                <div className="emp-detail-item mb-0 d-flex justify-content-between">
                  <h4
                    className="sub-heading normal-font-weight textBlack mb-2"
                    style={{ fontSize: "16px" }}
                  >
                    Attachment
                  </h4>
                  {!empDetail.agreement.attachment ? (
                    <div>
                      <h4
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        No Attachment
                      </h4>
                    </div>
                  ) : (
                    <div className="uploaded-item position-relative mt-4 w-25">
                      <div className="upload-item-header">
                        <img
                          src={
                            fileNameWithExtension === "jpg" ||
                            fileNameWithExtension === "png" ||
                            fileNameWithExtension === "jpeg"
                              ? Common.ImageIcon
                              : Common.FileIcon
                          }
                          width="60px"
                          alt="uploaded-item"
                        />

                        <div className="upload-item-body d-flex justify-content-between align-items-center">
                          <p className="mb-0">{fileNameWithExtension}</p>
                          <div className="ms-auto text-end">
                            <a href={empDetail.agreement.attachment} download>
                              <img
                                src={Common.Download}
                                className="me-2"
                                width="18px"
                                height="18px"
                                alt="share"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Col sm="12">
                <h4
                  className="sub-heading normal-font-weight textBlack mb-4 mt-3"
                  style={{ fontSize: "24px" }}
                >
                  Evaluation Details
                </h4>
              </Col>
              {empDetail.evaluationDetail ? (
                <>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Obedient
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.evaluationDetail.obedient}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Behavior
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.evaluationDetail.behavior}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-0 d-flex justify-content-between"
                      controlId="formBasicEmail"
                    >
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Appearance
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.evaluationDetail.appearance}
                      </h5>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <h4
                        className="sub-heading normal-font-weight textBlack"
                        style={{ fontSize: "16px" }}
                      >
                        Remarks
                      </h4>
                      <h5
                        className="sub-heading normal-font-weight"
                        style={{ fontSize: "14px" }}
                      >
                        {empDetail.evaluationDetail.remarks}
                      </h5>
                    </Form.Group>
                  </Col>
                </>
              ) : (
                <Col sm="12">
                  <h3
                    className="sub-heading normal-font-weight"
                    style={{ fontSize: "14px" }}
                  >
                    No Evaluation Details Found
                  </h3>
                </Col>
              )}
              {empDetail.language.length > 0 && (
                <>
                  <Col sm="12">
                    <h3
                      className="sub-heading mb-4"
                      style={{ fontSize: "16px" }}
                    >
                      Languages
                    </h3>
                  </Col>
                  <Col sm="12">
                    <div className="table-responsive mb-4">
                      <table className="table text-center table-bordered">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "16px" }}>Sr.</th>
                            <th style={{ fontSize: "16px" }}>Language</th>
                            <th style={{ fontSize: "16px" }}>
                              Language Proficiency
                            </th>
                            <th style={{ fontSize: "16px" }}>Writing Skills</th>
                          </tr>
                        </thead>
                        <tbody>
                          {empDetail.language.map((item, index) => (
                            <tr key={index}>
                              <td style={{ fontSize: "14px" }}>{index + 1}</td>
                              <td style={{ fontSize: "14px" }}>
                                {item.selectedLanguage}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.languageProficiency}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.writingSkills}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </>
              )}
              {empDetail.experience.length > 0 && (
                <>
                  <Col sm="12">
                    <h3
                      className="sub-heading mb-4"
                      style={{ fontSize: "16px" }}
                    >
                      Experience:
                    </h3>
                  </Col>
                  <Col sm="12">
                    <div className="table-responsive mb-4">
                      <table className="table text-center table-bordered">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "16px" }}>Sr.</th>
                            <th style={{ fontSize: "16px" }}>Region</th>
                            <th style={{ fontSize: "16px" }}>Basic Salary</th>
                            <th style={{ fontSize: "16px" }}>
                              Experience Proficiency
                            </th>
                            <th style={{ fontSize: "16px" }}>Start Date</th>
                            <th style={{ fontSize: "16px" }}>End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {empDetail.experience.map((item, index) => (
                            <tr key={index}>
                              <td style={{ fontSize: "14px" }}>{index + 1}</td>
                              <td style={{ fontSize: "14px" }}>
                                {item.region}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.basicSalary}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.experienceProficiency}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.startDate
                                  ? new Date(
                                      item.startDate,
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.endDate
                                  ? new Date(item.endDate).toLocaleDateString()
                                  : "N/A"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </>
              )}
              {empDetail.skills.length > 0 && (
                <>
                  <Col sm="12">
                    <h3
                      className="sub-heading mb-4"
                      style={{ fontSize: "16px" }}
                    >
                      Extra Skills:
                    </h3>
                  </Col>
                  <Col sm="12">
                    <div className="table-responsive mb-4">
                      <table className="table text-center table-bordered">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "16px" }}>Sr.</th>
                            <th style={{ fontSize: "16px" }}>Skill Name</th>
                            <th style={{ fontSize: "16px" }}>
                              Skill Proficiency
                            </th>
                            <th style={{ fontSize: "16px" }}>Note</th>
                          </tr>
                        </thead>
                        <tbody>
                          {empDetail.skills.map((item, index) => (
                            <tr key={index}>
                              <td style={{ fontSize: "14px" }}>{index + 1}</td>
                              <td style={{ fontSize: "14px" }}>
                                {item.skillName}
                              </td>
                              <td style={{ fontSize: "14px" }}>
                                {item.skillProficiency}
                              </td>
                              <td style={{ fontSize: "14px" }}>{item.notes}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </Col>
      </Row>

      <div className="text-end mt-5">
        <button
          className="btn primary-button normal-font-weight"
          onClick={() => {
            dispatch(setDetailActiveTab("Attachments"));
            dispatch(setDetailPageAttachments(true));
            dispatch(setDetailPageBasicInfo(false));
          }}
          type="button"
          style={{ width: "15%" }}
        >
          Next <img src={Common.ArrowRightWhite} alt="next" />
        </button>
      </div>
    </>
  );
};

export default BasicInfo;
